import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import IssueRootCausesAdminTableContainer from './IssueRootCausesAdminTableContainer';
import IssueRootCauseCategoryAdminCreateModalContainer from './IssueRootCauseCategoryAdminCreateModalContainer';
import Text from '@adsk/bim360-matrix-react-text';
import Button from '@adsk/bim360-matrix-react-button';
import Loader from '@adsk/bim360-matrix-react-loader';
import EmptyState from '@adsk/bim360-matrix-react-empty-state';
import ModalConfirmation from '@adsk/bim360-matrix-react-modal-confirmation';
import {NotificationTypes, NotificationLevels} from '@adsk/bim360-matrix-react-notification-manager/es/helpers/consts';
import i18n from '../../../utils/i18n';
import {issueRootCausesAdminVisit} from '../../../utils/analytics-helpers';
import IssueRootCausesAdminChangeStatusModal from './IssueRootCausesAdminChangeStatusModal';

class IssueRootCausesAdmin extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      createCategoryModalOpen: false,
      changeStatusModalOpen: false,
      deleteRootCauseCategoryConfirmationModalOpen: false,
      deleteRootCauseConfirmationModalOpen: false,
      currentEditedEntity: null,
      highlightLastRow: false,
      entityForDeletion: null,
      isDeleting: false
    };

    this.onStatusChange = this.onStatusChange.bind(this);
    this.setEntityStatus = this.setEntityStatus.bind(this);
    this.onChangeStatusModalClose = this.onChangeStatusModalClose.bind(this);
    this.closeDeleteRootCauseCategoryConfirmationModal = this.closeDeleteRootCauseCategoryConfirmationModal.bind(this);
    this.closeDeleteRootCauseConfirmationModal = this.closeDeleteRootCauseConfirmationModal.bind(this);
    this.openDeleteConfirmationModal = this.openDeleteConfirmationModal.bind(this);
    this.deleteIssueRootCause = this.deleteIssueRootCause.bind(this);
    this.closeRootCauseCategoryInUseModal = this.closeRootCauseCategoryInUseModal.bind(this);
    this.closeRootCauseInUseModal = this.closeRootCauseInUseModal.bind(this);
    this.onRootCauseCategoryInUseError = this.onRootCauseCategoryInUseError.bind(this);
    this.onRootCauseInUseError = this.onRootCauseInUseError.bind(this);
    this.onDeleteRootCauseFinished = this.onDeleteRootCauseFinished.bind(this);
    this.onDeleteRootCauseCategorySuccess = this.onDeleteRootCauseCategorySuccess.bind(this);
    this.openCreateCategoryModal = this.openCreateCategoryModal.bind(this);
  }

  componentWillMount() {
    //MixPanel Event - when user enters root causes admin page
    this.props.trackEvent(issueRootCausesAdminVisit());
  }

  fetchIssueRootCausesAction() {
    this.props.fetchIssueRootCausesAction();
  }

  onStatusChange(issueRootCause) {
    const {isActive, parentId} = issueRootCause;
    const parent = parentId ? this.props.data[parentId] : null;
    if (!isActive && parent && parent.isActive === false) {
      this.setState({changeStatusModalOpen: true, currentEditedEntity: issueRootCause});
    } else {
      this.setEntityStatus(issueRootCause);
    }
  }

  setEntityStatus(issueRootCause) {
    const {id, isActive, parentId} = issueRootCause;
    this.props.updateIssueRootCausesStatusAction(id, !isActive, parentId);
  }

  openCreateCategoryModal() {
    this.setState({createCategoryModalOpen: true});
  }

  onChangeStatusModalClose() {
    this.setState({changeStatusModalOpen: false, currentEditedEntity: null});
  }

  onCreateCategorySuccess() {
    this.props.scrollDown();
    this.setState({highlightLastRow: true}, () => {
      setTimeout(() => {
        this.setState({highlightLastRow: false});
      }, 4000);
    });
  }

  onCreateIssueRootCauseCategoryModalClose() {
    this.setState({createCategoryModalOpen: false});
  }

  deleteIssueRootCause() {
    const {id, parentId, title} = this.state.entityForDeletion;
    this.setState({isDeleting: true});
    if (parentId) {
      this.props.deleteIssueRootCauseAction({
        id,
        parentId,
        title,
        meta: {
          onSuccess: () => this.onDeleteRootCauseSuccess({title}),
          onError: () => this.onDeleteRootCauseFailed({title}),
          onRootCauseInUseError: () => this.onRootCauseInUseError({title})
        }
      });
    } else {
      this.props.deleteIssueRootCauseCategoryAction({
        id,
        title,
        meta: {
          onSuccess: () => this.onDeleteRootCauseCategorySuccess({title}),
          onError: () => this.onDeleteRootCauseCategoryFailed({title}),
          onRootCauseCategoryInUseError: this.onRootCauseCategoryInUseError
        }
      });
    }
  }

  onDeleteRootCauseFinished() {
    this.setState({isDeleting: false, entityForDeletion: null});
    this.closeDeleteRootCauseConfirmationModal();
  }

  onDeleteRootCauseSuccess({title}) {
    this.onDeleteRootCauseFinished();
    this.props.showNotificationAction({
      type: NotificationTypes.TOAST,
      level: NotificationLevels.SUCCESS,
      message: (
        <Text hasHTML>
          {i18n.t('issueRootCauses.notifications.deleteSuccessIssueRootCause', {
            issueRootCauseCategoryName: title
          })}
        </Text>
      )
    });
  }

  onDeleteRootCauseFailed({title}) {
    this.onDeleteRootCauseFinished();
    this.props.showNotificationAction({
      type: NotificationTypes.SNACKBAR,
      level: NotificationLevels.ERROR,
      message: (
        <Text hasHTML>
          {i18n.t('issueRootCauses.notifications.deleteErrorIssueRootCause', {
            issueRootCauseCategoryName: title
          })}
        </Text>
      )
    });
  }

  onDeleteCategoryFinished() {
    this.setState({isDeleting: false, entityForDeletion: null});
    this.closeDeleteRootCauseCategoryConfirmationModal();
  }

  onDeleteRootCauseCategorySuccess({title}) {
    this.onDeleteCategoryFinished();
    this.props.showNotificationAction({
      type: NotificationTypes.TOAST,
      level: NotificationLevels.SUCCESS,
      message: (
        <Text hasHTML>
          {i18n.t('issueRootCauses.notifications.deleteSuccessIssueRootCauseCategory', {
            issueRootCauseCategoryName: title
          })}
        </Text>
      )
    });
  }

  onDeleteRootCauseCategoryFailed({title}) {
    this.onDeleteCategoryFinished();
    this.props.showNotificationAction({
      type: NotificationTypes.SNACKBAR,
      level: NotificationLevels.ERROR,
      message: (
        <Text hasHTML>
          {i18n.t('issueRootCauses.notifications.deleteErrorIssueRootCauseCategory', {
            issueRootCauseCategoryName: title
          })}
        </Text>
      )
    });
  }

  openDeleteConfirmationModal(entityForDeletion) {
    if (entityForDeletion.parentId) {
      this.setState({entityForDeletion, deleteRootCauseConfirmationModalOpen: true});
    } else {
      this.setState({entityForDeletion, deleteRootCauseCategoryConfirmationModalOpen: true});
    }
  }

  onRootCauseInUseError() {
    this.setState({deleteRootCauseConfirmationModalOpen: false});
    this.props.toggleRootCauseInUseModalAction(true);
  }

  onRootCauseCategoryInUseError() {
    this.setState({deleteRootCauseCategoryConfirmationModalOpen: false});
    this.props.toggleRootCauseCategoryInUseModalAction(true);
  }

  clearEntityForDeletionIfNeeded(newState) {
    this.setState(prevState => (prevState.isDeleting ? newState : {...newState, entityForDeletion: null}));
  }

  closeDeleteRootCauseConfirmationModal() {
    this.clearEntityForDeletionIfNeeded({deleteRootCauseConfirmationModalOpen: false});
  }

  closeDeleteRootCauseCategoryConfirmationModal() {
    this.clearEntityForDeletionIfNeeded({deleteRootCauseCategoryConfirmationModalOpen: false});
  }

  getInUseModalMessage() {
    let isActive = false;
    let listItems = null;
    let primaryMessage = '';
    const secondaryMessage = i18n.t('issueRootCauses.modal.deleteErrorIssueRootCauseSetAsInactive');
    const entityForDeletion = this.state.entityForDeletion;

    if (entityForDeletion) {
      isActive = entityForDeletion.isActive;
      primaryMessage = entityForDeletion.parentId
        ? i18n.t('issueRootCauses.modal.deleteErrorIssueRootCause', {
          issueRootCauseName: entityForDeletion.title
        })
        : i18n.t('issueRootCauses.modal.deleteErrorIssueRootCauseCategory', {
          issueRootCauseCategoryName: entityForDeletion.title
        });

      const childrenIds = entityForDeletion.childrenIds;
      if (childrenIds && childrenIds.length > 0) {
        const rootCausesNames = childrenIds.reduce((names, id) => {
          if (this.props.data[id]) {
            return names.concat([this.props.data[id].title]);
          }
          return names;
        }, []);
        listItems = rootCausesNames ? (
          <ul>
            {rootCausesNames.map((name, index) => (
              <li key={index}>{name}</li>
            ))}
          </ul>
        ) : null;
      }
    }

    return (
      <React.Fragment>
        <div>
          <Text hasHTML>{primaryMessage}</Text>
        </div>
        {listItems}
        {isActive && (
          <span>
            <Text hasHTML>{secondaryMessage}</Text>
          </span>
        )}
      </React.Fragment>
    );
  }

  closeRootCauseCategoryInUseModal() {
    this.setState({entityForDeletion: null, isDeleting: false});
    this.props.toggleRootCauseCategoryInUseModalAction(false);
  }

  closeRootCauseInUseModal() {
    this.setState({entityForDeletion: null, isDeleting: false});
    this.props.toggleRootCauseInUseModalAction(false);
  }

  _renderTopButtons() {
    return (
      <div className="IssueRootCausesAdmin__buttons">
        <Button styleType={Button.StyleType.PRIMARY} onClick={this.openCreateCategoryModal}>
          {i18n.t('issueRootCauses.buttons.create')}
        </Button>
      </div>
    );
  }

  _renderTable() {
    return (
      <IssueRootCausesAdminTableContainer
        scrollDown={this.props.scrollDown}
        highlightLastRow={this.state.highlightLastRow}
        onStatusChange={this.onStatusChange}
        onDelete={this.openDeleteConfirmationModal}
      />
    );
  }

  _renderTryAgain() {
    return (
      <Button
        className="IssueRootCausesAdmin__empty-state-footer"
        onClick={this.fetchIssueRootCausesAction.bind(this)}
        styleType={Button.StyleType.INLINE_LINK}
      >
        {i18n.t('adminPages.emptyState.tryAgain')}
      </Button>
    );
  }

  _renderEmptyState() {
    return (
      <EmptyState
        icon={EmptyState.Icons.CONE}
        className="IssueRootCausesAdmin__empty-state"
        text={i18n.t('adminPages.emptyState.didntLoad')}
        footer={this._renderTryAgain()}
      />
    );
  }

  _renderCreateIssueRootCauseCategoryModal() {
    return (
      <IssueRootCauseCategoryAdminCreateModalContainer
        container={this}
        isOpen={this.state.createCategoryModalOpen}
        onCreateSuccess={this.onCreateCategorySuccess.bind(this)}
        onModalClose={this.onCreateIssueRootCauseCategoryModalClose.bind(this)}
      />
    );
  }

  _renderChangeStatusModal() {
    return (
      <IssueRootCausesAdminChangeStatusModal
        container={this}
        isOpen={this.state.changeStatusModalOpen}
        onModalClose={this.onChangeStatusModalClose}
        onConfirm={this.setEntityStatus}
        data={this.state.currentEditedEntity}
      />
    );
  }

  _renderDeleteIssueRootCauseCategoryConfirmationModal() {
    const title = this.state.entityForDeletion ? this.state.entityForDeletion.title : '';
    const message = (
      <Text hasHTML>
        {i18n.t('issueRootCauses.modal.deleteIssueRootCauseCategoryConfirmation', {
          issueRootCauseCategoryName: title
        })}
      </Text>
    );

    return (
      <ModalConfirmation
        container={this}
        title={i18n.t('issueRootCauses.modal.deleteRootCauseCategoryTitle')}
        show={this.state.deleteRootCauseCategoryConfirmationModalOpen}
        onConfirm={this.deleteIssueRootCause}
        disableModalExit={this.props.isDeleting}
        isOnConfirmInProgress={this.props.isDeleting}
        confirmationButtonLabelInProgress={i18n.t('issueRootCauses.modal.deleting')}
        onHide={this.closeDeleteRootCauseCategoryConfirmationModal}
        onExited={this.closeDeleteRootCauseCategoryConfirmationModal}
        message={message}
        confirmationButtonLabel={i18n.t('issueRootCauses.modal.delete')}
      />
    );
  }

  _renderDeleteIssueRootCauseConfirmationModal() {
    return (
      <ModalConfirmation
        container={this}
        title={i18n.t('issueRootCauses.modal.deleteRootCauseTitle')}
        show={this.state.deleteRootCauseConfirmationModalOpen}
        onConfirm={this.deleteIssueRootCause}
        disableModalExit={this.props.isDeleting}
        isOnConfirmInProgress={this.props.isDeleting}
        confirmationButtonLabelInProgress={i18n.t('issueRootCauses.modal.deleting')}
        onHide={this.closeDeleteRootCauseConfirmationModal}
        onExited={this.closeDeleteRootCauseConfirmationModal}
        message={<Text hasHTML>{i18n.t('issueRootCauses.modal.deleteIssueRootCauseConfirmation')}</Text>}
        confirmationButtonLabel={i18n.t('issueRootCauses.modal.delete')}
      />
    );
  }

  _renderRootCauseCategoryInUseModal() {
    return (
      <ModalConfirmation
        container={this}
        title={i18n.t('issueRootCauses.modal.categoryInUseTitle')}
        show={this.props.showRootCauseCategoryInUseModal}
        onConfirm={this.closeRootCauseCategoryInUseModal}
        onHide={this.closeRootCauseCategoryInUseModal}
        onExited={this.closeRootCauseCategoryInUseModal}
        message={this.getInUseModalMessage()}
        confirmationButtonLabel={i18n.t('issueRootCauses.modal.gotIt')}
        confirmationButtonStyleType={Button.StyleType.PRIMARY}
      />
    );
  }

  _renderRootCauseInUseModal() {
    return (
      <ModalConfirmation
        container={this}
        title={i18n.t('issueRootCauses.modal.rootCauseInUseTitle')}
        show={this.props.showRootCauseInUseModal}
        onConfirm={this.closeRootCauseInUseModal}
        onHide={this.closeRootCauseInUseModal}
        onExited={this.closeRootCauseInUseModal}
        message={this.getInUseModalMessage()}
        confirmationButtonLabel={i18n.t('issueRootCauses.modal.gotIt')}
        confirmationButtonStyleType={Button.StyleType.PRIMARY}
      />
    );
  }

  render() {
    const {isLoading, error, data} = this.props;

    if (isLoading) {
      return <Loader />;
    }

    if (error || Object.keys(data).length === 0) {
      return this._renderEmptyState();
    }

    return (
      <div className="IssueRootCausesAdmin">
        {this._renderTopButtons()}
        {this._renderTable()}
        {this._renderCreateIssueRootCauseCategoryModal()}
        {this._renderChangeStatusModal()}
        {this._renderDeleteIssueRootCauseConfirmationModal()}
        {this._renderDeleteIssueRootCauseCategoryConfirmationModal()}
        {this._renderRootCauseInUseModal()}
        {this._renderRootCauseCategoryInUseModal()}
      </div>
    );
  }
}

IssueRootCausesAdmin.displayName = 'IssueRootCausesAdmin';

IssueRootCausesAdmin.propTypes = {
  fetchIssueRootCausesAction: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  isDeleting: PropTypes.bool.isRequired,
  error: PropTypes.bool,
  scrollDown: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
  showNotificationAction: PropTypes.func.isRequired,
  updateIssueRootCausesStatusAction: PropTypes.func.isRequired,
  deleteIssueRootCauseCategoryAction: PropTypes.func.isRequired,
  deleteIssueRootCauseAction: PropTypes.func.isRequired,
  showRootCauseCategoryInUseModal: PropTypes.bool.isRequired,
  showRootCauseInUseModal: PropTypes.bool.isRequired,
  toggleRootCauseCategoryInUseModalAction: PropTypes.func.isRequired,
  toggleRootCauseInUseModalAction: PropTypes.func.isRequired
};

export default IssueRootCausesAdmin;
